import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import { useI18n } from '../i18n/I18nProvider';
import { getVersion } from '../services/versionService';
import RoleBadge from './RoleBadge';

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  const { t } = useI18n();
  const [user, setUser] = useState(() => authService.getCurrentUser());
  const displayName = user ? ([user.last_name, user.first_name].filter(Boolean).join(' ') || user.username || user.email || '') : '';
  const [version, setVersion] = useState('');
  const superMail = String('superadmin@unicomp.hu').toLowerCase();
  const isSuperadmin = (String(user?.role || '').toLowerCase() === 'superadmin') || (String(user?.email || '').toLowerCase() === superMail);

  useEffect(() => {
    if (!displayName && user?.token) {
      authService.fetchProfile().then(updated => {
        if (updated) setUser(updated);
      }).catch(() => {});
    }
  }, [displayName, user?.token]);
  useEffect(() => {
    const handler = () => {
      const refreshed = authService.getCurrentUser();
      if (refreshed) setUser(refreshed);
    };
    window.addEventListener('auth:user-updated', handler);
    return () => window.removeEventListener('auth:user-updated', handler);
  }, []);
  useEffect(() => {
    getVersion().then(v => setVersion(v));
  }, []);

  return (
    <>
      <h1>
        <img src="/logo-smartbin.svg" alt="SmartBin" className="app-logo" />
        <span className="brand-text">SmartBin</span>
        {version && <span className="app-version-badge" title={`v${version}`}>v{version}</span>}
      </h1>
      <div className="app-header-right">
        {isSuperadmin && (
          <span
            className="superadmin-avatar"
            title={t('users.protectedSuperadminBadge') || 'Superadmin (protected)'}
            style={{
              width: 26,
              height: 26,
              borderRadius: '50%',
              background: '#1f4e79',
              color: '#fff',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: 8,
              boxShadow: '0 0 0 2px rgba(255,255,255,0.25)'
            }}
            aria-label="superadmin"
          >
            <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
              <path d="M12 2l2.39 4.84 5.34.78-3.86 3.76.91 5.32L12 14.77 7.22 16.7l.91-5.32L4.27 7.62l5.34-.78L12 2z" />
            </svg>
          </span>
        )}
  {user?.role && <RoleBadge role={user.role} />}
  {displayName && <span className="app-user-name" title={displayName}>{displayName}</span>}
        <button className="btn btn-outline-light" onClick={handleLogout}>{t('logout')}</button>
      </div>
    </>
  );
};

export default Header;